<script setup lang="ts">
/**
 * Footer V2 — Advertência (ENG-404, itens 3 e 5).
 *
 * Reusa o bloco de compliance (BaseComplianceInfo): advertência oficial
 * rotativa + 18+ + identificação (autorização/domínio), em texto discreto no
 * topo do footer. Como o footer é global (layouts/default.vue), garante a
 * advertência em todas as páginas que o renderizam.
 */
</script>

<template>
  <div class="footer-v2-warning">
    <BaseComplianceInfo class="footer-v2-warning__info" />
  </div>
</template>

<style scoped lang="scss">
.footer-v2-warning {
  display: flex;
  width: 100%;
  justify-content: center;

  &__info {
    max-width: 640px;
  }
}
</style>
